import bookingViewStyles from '../BookingView/styles';

export default {
    paperContainer: bookingViewStyles.paperContainer,
    contentContainer: bookingViewStyles.contentContainer,
};
